import { Injectable } from '@angular/core';

import { SubscriptionCommands } from '../../../../../../../../data/dietitian/domain/subscription/subscription_commands';
import { SubscriptionFeature } from '../../../../../../../../data/dietitian/domain/subscription/subscription_feature';

@Injectable()
export class FeatureByCodePopupFacade {
  constructor(private subscriptionCommands: SubscriptionCommands) {
    // Nada
  }

  async subscribeCodedFeature(
    dietitianId: string,
    codedFeatureId: string,
    code: string,
  ): Promise<SubscriptionFeature | undefined> {
    return this.subscriptionCommands.subscribeCodedFeature(
      dietitianId,
      codedFeatureId,
      code,
    );
  }
}
